import React, { useEffect } from 'react';
import styles from './Dashboard.module.scss'
import DateRangeSelector from 'components/miscellaneous/DateRangeSelector/DateRangeSelector';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import {getUserClinic} from "store/auth-slice";
import StatisticsWidget from 'components/Chain/Dashboard/StatisticsWidget/StatisticsWidget';
import DashboardBox from "components/miscellaneous/DashboardBox/DashboardBox";
import { $t } from 'helpers/translator';
import TreatmentsGraph from 'components/Admin/Dashboard/TreatmentsGraph/TreatmentsGraph';
import ApplicatorsWidget from 'components/Chain/Dashboard/ApplicatorsWidget/ApplicatorsWidget';
import ClinicsMap from 'components/Chain/Dashboard/ClinicsMap/ClinicsMap';
import ClinicUsageWidget from 'components/Chain/Dashboard/ClinicUsageWidget/ClinicUsageWidget';
import TopStaffWidget from 'components/clinic/Dashboard/TopStaffWidget/TopStaffWidget'

const ChainDashboard = () => {
    const dispatch = useDispatch();
    const [dateRange, setDateRange] = React.useState({
        startDate: moment().subtract(1, 'month').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
    });
    const [clinic, setClinic] = React.useState(null);

    useEffect(() => {
        dispatch(getUserClinic()).then((res) => {
            setClinic(res)
        })
    }, [])

    return (
        <div className={styles.dashboardContainer}>
            <div className={styles.container}>
                <div className={`d-flex justify-content-between ${styles.header}`}>
                    <h1 className={styles.title}>Welcome Back, {clinic !== null && clinic.name}</h1>
                    <DateRangeSelector onChange={(data) => {
                        setDateRange(data);
                    }} />
                </div>

                <div className={styles['row']}>
                    <StatisticsWidget dateRange={dateRange} />
                </div>

                <div className={styles['row']}>
                    <div className={`${styles['component-block']} ${styles['col6']}`}>
                        <div className={ styles.widget }>
                            <DashboardBox style={{height: '100%'}} info={ $t('global.chainDashboard.myClinicsInfo')} header={"My Clinics"}>
                                <ClinicsMap zoom={2} maxHeight={"300px"} />
                            </DashboardBox>
                        </div>
                    </div>
                    <div className={`${styles['component-block']} ${styles['col6']}`}>
                        <div className={ styles.widget }>
                            <DashboardBox info={"Showing the 10 most popular treatment areas"}
                                header={ "Most Popular Treatments" }>
                                <TreatmentsGraph dateRange={dateRange} />
                            </DashboardBox>
                        </div>
                    </div>
                </div>

                <div className={styles['row']} style={{paddingTop: 0, flexWrap: 'wrap'}}>
                    <div className={`${styles['component-block']} ${styles['col6']} ${styles['staffAndPlatforms']}`} style={{margin: 0}}>
                        <div className={styles['row']} style={{padding: 0, height: '100%'}}>
                            <div className={ styles['component-block'] } style={{margin: 0}} >
                                <DashboardBox info={$t('global.chainDashboard.topStaffMembersInfo')}
                                header={$t('global.chainDashboard.topStaffMembers')}>
                                    <TopStaffWidget dateRange={dateRange} small={true} stack={false} />
                                </DashboardBox>
                            </div>
                            <div className={ styles['component-block'] } style={{margin: 0}}>
                                <DashboardBox info={$t('global.chainDashboard.platformUsageStatisticsInfo')}
                                header={$t('global.chainDashboard.platformUsageStatistics')}>
                                    <ClinicUsageWidget dateRange={dateRange} />
                                </DashboardBox>
                            </div>
                        </div>
                    </div>
                    <div className={`${styles['component-block']} ${styles['col6']}`} style={{margin: 0}}>
                        <div className={ styles.widget } style={{margin: 0, height: '100%'}}>
                            <DashboardBox info={$t('global.chainDashboard.mostUsedApplicatorsInfo')}
                                header={$t('global.chainDashboard.mostUsedApplicators')}>
                                <ApplicatorsWidget dateRange={dateRange} />
                            </DashboardBox>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default ChainDashboard;